var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommunication(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0293 20.3247L5.88514 25V20.3247H4C2.89543 20.3247 2 19.4292 2 18.3247V6C2 4.89543 2.89543 4 4 4H23C24.1046 4 25 4.89543 25 6V18.3247C25 19.4292 24.1046 20.3247 23 20.3247H11.0293Z",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 24.9643H21.4393L26.6124 29V24.9643H28C29.1046 24.9643 30 24.0689 30 22.9643V11C30 9.89543 29.1046 9 28 9H27.4961",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 8H21.5",
    stroke: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6 12H21.5",
    stroke: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6 16H17",
    stroke: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunication);
export default __webpack_public_path__ + "static/media/communication.1e850ad34c8baa03a57b4ec8bd36c5d8.svg";
export { ForwardRef as ReactComponent };